import { yupResolver } from "@hookform/resolvers/yup";
import FalconLightBox from "components/common/FalconLightBox";
import { useEffect, useState } from "react";
import { Col, Form, Image, Row } from "react-bootstrap";
import { useForm, useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { BASEURL } from "utils/customConfig";

import * as yup from "yup";

const schema = yup
    .object({
        businessName: yup.string().required("This field is required"),
        type: yup.string().required("This field is required"),
        cnic: yup.string().required("This field is required"),
        ntn: yup.string().required("This field is required"),
        address: yup.string().required("This field is required"),
        city: yup.string().required("This field is required"),
        state: yup.string().required("This field is required"),
        postalCode: yup.string().required("This field is required"),
        country: yup.string().required("This field is required"),
        logo: yup.string(),
        mainImage: yup.string(),
        status: yup.boolean(),
    })
    .required();


export default function StoreInfoTabContent({ data }) {

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {},
    });

    const { reset, setValue, formState: { errors }, register } = methods;

    const [logoFile, setLogoFile] = useState(null);
    const [mainImageFile, setMainImageFile] = useState(null);
    const maxCharactersLength = 255;


    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [setValue]);

    return <>
        <Row className="gx-2 pb-2 mt-2">


            <Col md="6">
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder="Name"
                        title="Name"
                        maxLength={maxCharactersLength}
                        className="py-2 "
                        isInvalid={!!errors.businessName}
                        {...register("businessName")}
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Control.Feedback
                            type="invalid"
                            className="d-inline w-75"
                        >
                            {errors.businessName?.message}
                        </Form.Control.Feedback>
                    </div>
                </Form.Group>
            </Col>

            <Col md="6">
                <Form.Group>
                    <Form.Select
                        aria-label="type"
                        type="text"
                        title="Type"
                        className="py-2"
                        isInvalid={!!errors?.type}
                        {...register("type")}
                    >
                        <option value="">Select type</option>
                        <option value="Individual">Individual</option>
                        <option value="Organization">Organization</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                        {errors?.type?.message}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>

            <Col md="6">
                <Form.Group>
                    <Form.Control
                        type="number"
                        placeholder="CNIC / Passport"
                        title="CNIC / Passport"
                        maxLength={maxCharactersLength}
                        className="py-2 "
                        isInvalid={!!errors.cnic}
                        {...register("cnic")}
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Control.Feedback
                            type="invalid"
                            className="d-inline w-75"
                        >
                            {errors.cnic?.message}
                        </Form.Control.Feedback>
                    </div>
                </Form.Group>
            </Col>
            <Col md="6">
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder="NTN"
                        title="NTN"
                        maxLength={maxCharactersLength}
                        className="py-2 "
                        isInvalid={!!errors.ntn}
                        {...register("ntn")}
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Control.Feedback
                            type="invalid"
                            className="d-inline w-75"
                        >
                            {errors.ntn?.message}
                        </Form.Control.Feedback>
                    </div>
                </Form.Group>
            </Col>
            <Col md="6">
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder="Address"
                        title="Address"
                        maxLength={maxCharactersLength}
                        className="py-2 "
                        isInvalid={!!errors.address}
                        {...register("address")}
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Control.Feedback
                            type="invalid"
                            className="d-inline w-75"
                        >
                            {errors.address?.message}
                        </Form.Control.Feedback>
                    </div>
                </Form.Group>
            </Col>
            <Col md="6">
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder="City"
                        title="City"
                        maxLength={maxCharactersLength}
                        className="py-2 "
                        isInvalid={!!errors.city}
                        {...register("city")}
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Control.Feedback
                            type="invalid"
                            className="d-inline w-75"
                        >
                            {errors.city?.message}
                        </Form.Control.Feedback>
                    </div>
                </Form.Group>
            </Col>
            <Col md="6">
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder="State"
                        title="State"
                        maxLength={maxCharactersLength}
                        className="py-2 "
                        isInvalid={!!errors.state}
                        {...register("state")}
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Control.Feedback
                            type="invalid"
                            className="d-inline w-75"
                        >
                            {errors.state?.message}
                        </Form.Control.Feedback>
                    </div>
                </Form.Group>
            </Col>
            <Col md="6">
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder="Country"
                        title="Country"
                        maxLength={maxCharactersLength}
                        className="py-2 "
                        isInvalid={!!errors.country}
                        {...register("country")}
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Control.Feedback
                            type="invalid"
                            className="d-inline w-75"
                        >
                            {errors.country?.message}
                        </Form.Control.Feedback>
                    </div>
                </Form.Group>
            </Col>
            <Col md="6">
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder="Postal Code"
                        title="Postal Code"
                        maxLength={maxCharactersLength}
                        className="py-2 "
                        isInvalid={!!errors.postalCode}
                        {...register("postalCode")}
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Control.Feedback
                            type="invalid"
                            className="d-inline w-75"
                        >
                            {errors.postalCode?.message}
                        </Form.Control.Feedback>
                    </div>
                </Form.Group>
            </Col>
            <Col md="6">
                <div className="d-flex align-items-center justify-content-between gap-3">
                    <div className="d-flex gap-3">

                        <div className="d-flex">


                            {/* <Col md={file || (state?.logoFile?.fileBase64 ? "2" : "1")}> */}
                            {logoFile || data?.logo ? (
                                <FalconLightBox
                                    image={
                                        logoFile
                                            ? logoFile.preview
                                            : `${BASEURL}/wwwroot${data.logo}`
                                    }
                                >
                                    <Image
                                        src={
                                            logoFile
                                                ? logoFile.preview
                                                : `${BASEURL}/wwwroot${data.logo}`
                                        }
                                        title="Logo"
                                        rounded
                                        width={80}
                                        height={40}
                                    />
                                </FalconLightBox>
                            ) : null}
                            {/* Render nothing if both file and state.logoFile.fileBase64 are not present */}
                        </div>
                        <div className="d-flex px-2">


                            {/* <Col md={file || (state?.logoFile?.fileBase64 ? "2" : "1")}> */}
                            {mainImageFile || data?.mainImage ? (
                                <FalconLightBox
                                    image={
                                        mainImageFile
                                            ? mainImageFile.preview
                                            : `${BASEURL}/wwwroot${data.mainImage}`
                                    }
                                >
                                    <Image
                                        src={
                                            mainImageFile
                                                ? mainImageFile.preview
                                                : `${BASEURL}/wwwroot${data.mainImage}`
                                        }
                                        title="Banner Image"
                                        rounded
                                        width={80}
                                        height={40}
                                    />
                                </FalconLightBox>
                            ) : null}
                            {/* Render nothing if both file and state.logoFile.fileBase64 are not present */}
                        </div>
                    </div>
                    <Form.Group >
                        <Form.Check
                            type="checkbox"
                            id="defaultSwitch"
                            label="Active"
                            className="mt-2"
                            defaultChecked={!data}
                            isInvalid={!!errors.status}
                            {...register("status")}
                        />

                    </Form.Group>
                </div>
            </Col>
        </Row>
    </>
}